import {
	Box,
	Button,
	FormControl,
	FormErrorMessage,
	FormLabel,
	Input,
	Link,
	Text,
} from '@chakra-ui/react';
import React, { useContext, useEffect } from 'react';
import { Link as ReactRouterLink, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { signupResolver } from '../../utils/validator/signupResolver';
import { auth } from '../../utils/firebase';
import Store from '../../utils/Store';
import { FaFacebook, FaGoogle } from 'react-icons/fa';

const Signup = () => {
	const {
		handleSubmit,
		register,
		formState: { errors, isSubmitting },
		setError,
		clearErrors,
	} = useForm({ resolver: signupResolver });

	const { user, handleFbSignIn, handleGoogleSignIn } = useContext(Store);

	// console.log(auth);

	const history = useHistory();

	//add user display name
	const updateUserDisplayName = (name) => {
		const user = auth.currentUser;
		console.log(user);

		user.updateProfile({
			displayName: name,
			// photoURL: 'https://example.com/jane-q-user/profile.jpg',
		});
	};

	const onSubmit = ({ name, email, password }) => {
		clearErrors('API_ERROR');
		// firebase
		auth
			.createUserWithEmailAndPassword(email, password)
			.then(() => {
				history.push('/');
				updateUserDisplayName(name);
			})
			.catch((err) => {
				setError('API_ERROR', { message: err.message });
			});
	};

	// check user login or not
	useEffect(() => {
		if (user) {
			history.push('/');
			console.log(user);
		}
	}, [user, history]);

	return (
		<Box
			width='100%'
			minH='100vh'
			background='gray.200'
			d='flex'
			alignItems='center'
			justifyContent='center'
			marginTop='20px'
		>
			<Box
				width={{ base: '90%', md: '40%', lg: '30%' }}
				shadow='lg'
				background='white'
				p={6}
				rounded={6}
			>
				<Box textAlign='center'>
					<Text fontSize='2xl' mb='2'>
						Sign Up
					</Text>
				</Box>
				<form onSubmit={handleSubmit(onSubmit)}>
					<FormControl isInvalid={errors.name}>
						<FormLabel htmlFor='name'>Name</FormLabel>
						<Input
							type='text'
							name='name'
							placeholder='Enter your Name'
							{...register('name')}
						/>
						<FormErrorMessage>
							{errors.name && errors.name.message}
						</FormErrorMessage>
					</FormControl>

					<FormControl mt='2' isInvalid={errors.email}>
						<FormLabel htmlFor='email'>Email</FormLabel>
						<Input
							type='email'
							name='email'
							placeholder='Enter your Email'
							{...register('email')}
						/>
						<FormErrorMessage>
							{errors.email && errors.email.message}
						</FormErrorMessage>
					</FormControl>

					<FormControl mt='2' isInvalid={errors.password}>
						<FormLabel htmlFor='password'>Password</FormLabel>
						<Input
							type='password'
							name='password'
							placeholder='Enter your Password'
							{...register('password')}
						/>
						<FormErrorMessage>
							{errors.password && errors.password.message}
						</FormErrorMessage>
					</FormControl>

					<FormControl mt='2' isInvalid={errors.repeat_password}>
						<FormLabel htmlFor='repeat_password'>Repeat Password</FormLabel>
						<Input
							type='password'
							name='repeat_password'
							placeholder='Enter your Repeat Password'
							{...register('repeat_password')}
						/>
						<FormErrorMessage>
							{errors.repeat_password && errors.repeat_password.message}
						</FormErrorMessage>
					</FormControl>
					<Box mt='3' color='red.400'>
						{errors.API_ERROR && errors.API_ERROR.message}
					</Box>
					<Button
						isLoading={isSubmitting}
						type='submit'
						my='2'
						w='100%'
						colorScheme='messenger'
					>
						Sign Up
					</Button>
				</form>
				<Text textAlign='center'> or</Text>
				<Button
					isLoading={isSubmitting}
					type='submit'
					mt='2'
					w='100%'
					colorScheme='red'
					onClick={handleGoogleSignIn}
					leftIcon={<FaGoogle />}
				>
					Sign In With Google
				</Button>
				<Button
					isLoading={isSubmitting}
					type='submit'
					mt='2'
					w='100%'
					colorScheme='facebook'
					leftIcon={<FaFacebook />}
					onClick={handleFbSignIn}
				>
					Sign In With Facebook
				</Button>
				<Text textAlign='center' p='2' size='xs'>
					<Link as={ReactRouterLink} to='/login' color='gray.500'>
						Already Register?
					</Link>
				</Text>
			</Box>
		</Box>
	);
};

export default Signup;
